import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	WHITE,
	STRONGORANGE,
	SIMPLEGRAY
} from '../../../../styles/colors.style'

export const Container = styled.div``

export const BoxCard = styled.section`
	height: 100%;
	max-width: 1024px;
	margin: 35px auto;
	display: block;
	text-align: center;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: flex;
		justify-content: center;
		img {
			margin-bottom: 40px;
		}
	}
`

export const ContainerTips = styled.section`
	color: ${WHITE};
	width: 100%;

	img {
		max-width: 100%;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
		img {
			max-width: 107%;

			&.-desk {
				width: 100%;
				display: block;
			}
		}
	}
`

export const Tips = styled.div`
	width: 80%;
	margin: 10px auto 30px;
	display: none;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 100%;
		margin: 0 0 30px;
		display: none;
	}

	p {
		margin: 0 0 10px;
		padding: 0;

		span {
			color: ${WHITE};
			background: ${STRONGORANGE};
			padding: 0 5px;
			font-size: 28px;
			line-height: 35px;
			font-weight: 600;
			text-transform: uppercase;
			height: 35px;
		}
	}

	.container-rounded {
		background: rgba(255, 255, 255, 0.9);
		border-radius: 5px;
		display: flex;

		ul {
			padding: 0 30px;
			li {
				padding: 5px 0;
				font-style: normal;
				font-size: 15px;
				align-items: center;
				color: ${SIMPLEGRAY};
			}
		}
	}
`
